//*** -- DONT CHANGE IT TO IMPORTS - Santa worker will fail to load that entry -- ***
const {viewerScriptConfig} = require('./viewerScriptConfig');
const {createViewerScript} = require('@wix/wixstores-client-core/dist/es/src/viewer-script/createViewerScript');

module.exports = createViewerScript(viewerScriptConfig, {useWorkerRaven: true});
